import type { TaxReturn } from '@/_types/models/taxReturns';

export const getCompletedSignatureCount = (taxReturn: TaxReturn): number => {
  return taxReturn.e_sign_forms.reduce((acc, form) => {
    const signedCount: number = form.signatures.filter((signature) => {
      if (form.wetSignaturesRequired) {
        return form.wetSignatures && form.wetSignatures.length > 0;
      } else {
        return signature.signatureData || signature.isMarkedSigned;
      }
    }).length;

    return acc + signedCount;
  }, 0);
};

export const getTotalSignatureCount = (taxReturn: TaxReturn): number =>
  taxReturn.e_sign_forms.reduce((acc, form) => acc + form.signatures.length, 0);

export const getRemainingSignatureCount = (taxReturn: TaxReturn): number =>
  getTotalSignatureCount(taxReturn) - getCompletedSignatureCount(taxReturn);
